/**
 * The two courses of spec 53 section 10.1, for the card's course bar
 * ("Dispatch a load · 3 of 7 · Assign it"). A chapter's own name is its
 * definition's title; this only knows what the course is called and how
 * many chapters it has.
 */
export const COURSES = Object.freeze({
  dispatch: Object.freeze({ title: 'Dispatch a load', chapters: 7 }),
  billing: Object.freeze({ title: 'Bill it and get paid', chapters: 3 }),
});

/** The bar for a definition, or null for a module outside a course. */
export function courseBar(definition) {
  const training = definition && definition.training;
  const course = training && COURSES[training.course];
  if (!course || !Number.isInteger(training.chapter)) return null;
  return {
    title: course.title,
    chapter: training.chapter,
    chapters: course.chapters,
    name: definition.title,
  };
}
